import React from 'react';
import { Users, ArrowUpRight, Plus } from 'lucide-react';

const DomainsPanel = ({ domains, selectedDomainId, onSelectDomain, onAddDomain }) => (
    <div className="col-span-1 md:col-span-2 bg-white rounded border border-gray-100 shadow-sm overflow-hidden flex flex-col h-full">
        <div className="px-4 py-3 border-b border-gray-100 flex items-center justify-between flex-shrink-0">
            <div className="flex items-center gap-2">
                <div className="w-7 h-7 rounded bg-primary/10 flex items-center justify-center">
                    <Users className="w-3.5 h-3.5 text-primary" />
                </div>
                <span className="text-sm font-semibold text-gray-800">Domains</span>
            </div>
            <button
                onClick={onAddDomain}
                className="w-6 h-6 hover:bg-gray-100 rounded transition-colors flex items-center justify-center"
            >
                <Plus className="w-3.5 h-3.5 text-primary" />
            </button>
        </div>
        <div className="flex-1 overflow-y-auto p-2 space-y-1">
            {domains.map((domain, idx) => (
                <button
                    key={domain.id}
                    onClick={() => onSelectDomain(idx)}
                    className={`w-full text-left px-3 py-2.5 rounded text-sm font-medium transition-all duration-150 flex items-center justify-between group ${
                        selectedDomainId === idx
                            ? 'bg-secondaryLight text-secondary shadow-sm'
                            : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                    }`}
                >
                    <span className="truncate">{domain.name}</span>
                    <ArrowUpRight className={`w-3.5 h-3.5 flex-shrink-0 ml-1 opacity-0 group-hover:opacity-100 transition-opacity ${selectedDomainId === idx ? 'opacity-60' : ''}`} />
                </button>
            ))}
            {domains.length === 0 && (
                <p className="text-gray-400 text-xs text-center py-6">No domains available</p>
            )}
        </div>
    </div>
);

export default DomainsPanel;
